import { Button, Modal, Text, toast } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { onboardingOyEmail } from 'src/constants/Email';
import { useTranslate } from 'src/hooks';
import { EMAIL_CONTENT } from '../../constants';
import styles from './ConfirmationModal.module.css';
// Trigger
export const EmailNotOpenModal = ({
  showEmailNotOpenModal,
  onCloseModalConfirmation,
}: {
  showEmailNotOpenModal: boolean;
  onCloseModalConfirmation: () => void;
}) => {
  const { getTranslation, lang } = useTranslate();
  const onCopy = (content: string) => {
    navigator.clipboard.writeText(content);
    toast.success(getTranslation('common_copyToClipboard'));
  };
  return (
    <Modal
      show={showEmailNotOpenModal}
      closeOnBackdropClick={false}
      disableOnClose
    >
      <Modal.Body>
        <Text textStyle={Text.Style.BodyXlSemibold}>
          {getTranslation('email_didnt_open')}
        </Text>

        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionItem}>
            <Text textStyle={Text.Style.BodyMdRegular}>
              <b>{getTranslation('common_to')}</b> : {onboardingOyEmail}
            </Text>
            <SystemIcon
              className={styles.descriptionItemCopy}
              name={'copy'}
              size={24}
              onClick={() => onCopy(onboardingOyEmail)}
            />
          </div>
          <div className={styles.descriptionItem}>
            <Text textStyle={Text.Style.BodyMdRegular}>
              <b>Subject</b> : {EMAIL_CONTENT.subject[lang]}
            </Text>
            <SystemIcon
              className={styles.descriptionItemCopy}
              name={'copy'}
              size={24}
              onClick={() => onCopy(EMAIL_CONTENT.subject[lang])}
            />
          </div>
          <div className={styles.descriptionItem}>
            <Text textStyle={Text.Style.BodyMdRegular}>
              <b>Body</b>
            </Text>
            <SystemIcon
              className={styles.descriptionItemCopy}
              name={'copy'}
              size={24}
              onClick={() => onCopy(EMAIL_CONTENT.body[lang])}
            />
          </div>
          <Text
            style={{ whiteSpace: 'pre-line' }}
            textStyle={Text.Style.BodyMdRegular}
          >
            {EMAIL_CONTENT.body[lang]}
          </Text>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button fullWidth onClick={onCloseModalConfirmation}>
          {getTranslation('common_close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
